'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CustomerChat = function (_Component) {
  _inherits(CustomerChat, _Component);

  function CustomerChat() {
    _classCallCheck(this, CustomerChat);

    var _this = _possibleConstructorReturn(this, (CustomerChat.__proto__ || Object.getPrototypeOf(CustomerChat)).call(this));

    _this.state = {};
    return _this;
  }

  _createClass(CustomerChat, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getInit();
      this.setupSdk();
    }
  }, {
    key: 'getInit',
    value: function getInit() {
      var _props = this.props,
          xfbml = _props.xfbml,
          version = _props.version;

      window.fbAsyncInit = function () {
        FB.init({
          xfbml: xfbml,
          version: version
        });
      };
    }
  }, {
    key: 'setupSdk',
    value: function setupSdk() {
      (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          pageId = _props2.pageId,
          attribute = _props2.attribute;
      return _react2.default.createElement('div', null, _react2.default.createElement('div', _extends({
        className: 'fb-customerchat'
      }, attribute, {
        page_id: pageId
      })));
    }
  }]);

  return CustomerChat;
}(_react.Component);

exports.default = CustomerChat;
var propTypes = {
  pageId: _propTypes2.default.string.isRequired,
  xfbml: _propTypes2.default.bool,
  version: _propTypes2.default.string
};
var defaultProps = {
  xfbml: true,
  version: 'v3.2'
};
CustomerChat.propTypes = propTypes;
CustomerChat.defaultProps = defaultProps;